import { useState } from "react";
import { Button, Flex, Text, Paper } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconUpload } from "@tabler/icons-react";
import { useImportTranslations } from "../../api/translations";
import { Dropzone } from "@mantine/dropzone";

function ImportTranslations() {
  const [file, setFile] = useState(null);

  const { mutate, isPending } = useImportTranslations();

  const handleImport = async () => {
    if (!file) return;

    // Convert file to base64
    const reader = new FileReader();
    reader.onload = async () => {
      const base64Data = reader.result;

      const payload = {
        file: {
          data: base64Data,
          name: file.name,
          type: file.type,
        },
      };

      mutate(payload, {
        onSuccess: () => {
          modals.closeAll();
        },
      });
    };

    reader.readAsDataURL(file);
  };
  const handleDrop = (files) => {
    if (files.length > 0) {
      setFile(files[0]);
    }
  };

  return (
    <Flex direction="column" gap="md">
      <Dropzone
        onDrop={handleDrop}
        accept={[
          "text/csv",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ]}
        maxFiles={1}
      >
        <Flex
          direction="column"
          align="center"
          justify="center"
          gap="sm"
          style={{ minHeight: 120, pointerEvents: "none" }}
        >
          <IconUpload size={32} stroke={1.5} />
          <Text size="sm" inline>
            Drag & drop your file here, or click to select
          </Text>
          <Text size="xs" c="dimmed" inline>
            Accepted formats: CSV, XLSX
          </Text>
        </Flex>
      </Dropzone>

      {file && (
        <Paper withBorder p="xs">
          <Text size="sm" fw={500}>
            Selected file:
          </Text>
          <Text size="sm" c="dimmed">
            {file.name}
          </Text>
        </Paper>
      )}

      <Button
        onClick={handleImport}
        loading={isPending}
        disabled={!file}
        fullWidth
      >
        Import Translations
      </Button>
    </Flex>
  );
}

export function openImportModal() {
  return modals.open({
    title: "Import Translations",
    children: <ImportTranslations />,
    size: "sm",
    transitionProps: { transition: "fade", duration: 300 },
  });
}

export default ImportTranslations;
